import { LegalDocumentScreen, type LegalSection } from '@/components/account/LegalDocumentScreen';

const sections: LegalSection[] = [
  {
    heading: 'Penerimaan syarat',
    paragraphs: [
      'Dengan menggunakan Funpaper, Anda menyetujui syarat penggunaan ini. Jika Anda tidak menyetujuinya, mohon tidak menggunakan layanan Funpaper.',
    ],
  },
  {
    heading: 'Penggunaan akun',
    paragraphs: [
      'Funpaper dibuat untuk orang tua atau pengasuh yang mendampingi anak. Anda bertanggung jawab atas keamanan akun, kebenaran informasi yang dimasukkan, dan aktivitas yang dilakukan melalui akun Anda.',
    ],
  },
  {
    heading: 'Penggunaan worksheet',
    paragraphs: [
      'Worksheet dan rekomendasi di Funpaper disediakan untuk membantu orang tua menemukan ide aktivitas. Gunakan dengan pendampingan dan pertimbangkan usia, kemampuan, serta kondisi anak sebelum memulai aktivitas.',
      'Konten Funpaper boleh digunakan untuk kebutuhan pribadi dan keluarga. Jangan menjual ulang, menyebarkan, mengubah, atau menggunakan kembali konten untuk tujuan komersial tanpa izin tertulis dari Terus Mengajar.',
    ],
  },
  {
    heading: 'Penggunaan yang tidak diperbolehkan',
    paragraphs: ['Saat menggunakan Funpaper, Anda tidak diperbolehkan untuk:'],
    bullets: [
      'menggunakan aplikasi untuk tujuan yang melanggar hukum atau merugikan orang lain;',
      'mencoba mengakses akun, data, atau sistem yang bukan milik Anda;',
      'mengganggu keamanan, kinerja, atau ketersediaan layanan; atau',
      'menyalin dan mendistribusikan bagian aplikasi atau kontennya tanpa izin.',
    ],
  },
  {
    heading: 'Ketersediaan layanan',
    paragraphs: [
      'Kami berusaha menjaga Funpaper tetap tersedia dan bermanfaat, tetapi fitur, rekomendasi, dan konten dapat berubah, ditunda, atau dihentikan untuk perbaikan. Kami akan berusaha memberi informasi yang wajar jika perubahan tersebut berdampak besar pada penggunaan aplikasi.',
    ],
  },
  {
    heading: 'Perubahan dan kontak',
    paragraphs: [
      'Anda dapat berhenti menggunakan Funpaper kapan saja. Kami dapat memperbarui syarat ini seiring perkembangan layanan; versi terbaru akan ditampilkan di halaman ini. Untuk pertanyaan, hubungi terusmengajar@gmail.com.',
    ],
  },
];

export default function SyaratPenggunaanScreen() {
  return (
    <LegalDocumentScreen
      title="Syarat Penggunaan"
      intro="Syarat ini membantu menjelaskan cara menggunakan Funpaper dengan aman dan nyaman untuk mendampingi aktivitas belajar anak."
      sections={sections}
    />
  );
}
